var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.601,
    height: 16.601,
    viewBox: "0 0 16.601 16.601",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clock-regular",
    d: "M7.522,3.891a.778.778,0,0,1,1.556,0V7.885l2.766,1.842a.751.751,0,0,1,.188,1.08.714.714,0,0,1-1.051.188L7.869,8.92a.711.711,0,0,1-.347-.648ZM8.3,0A8.3,8.3,0,1,1,0,8.3,8.3,8.3,0,0,1,8.3,0ZM1.556,8.3A6.744,6.744,0,1,0,8.3,1.556,6.743,6.743,0,0,0,1.556,8.3Z",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/history.bbc9ed1d5641af2db31302a970c2d2d3.svg";